var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.firstBatchOfThumbnailsAvailable)?_c('div',_vm._l((_vm.options.data),function(item){return _c('pictureBox',{key:item.FileName,attrs:{"options":_vm.options,"template":item,"keep-alive":""}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }